import script from "./ShopIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShopIndex.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__